// Dependencies
import React, { Component } from 'react';
import { Col, Row, Container } from 'reactstrap';
import { connect } from 'react-redux';
import iconoResultado from '../../../src/assets/images/icono-resultados.svg';

//Components
import ResultsPageContainer from './../../containers/Results/ResultsPageContainer';
import CountdownTimer from './../Global/Header/CountdownTimer';

//Actions
import { getPageInfo } from './../../reducers/generalReducer';

//Components
import Breadcrumbs from './../Global/Breadcrumbs/Breadcrumbs';

class Results extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { info } = this.props;
    const {
      match: {
        params: {
          date = null
        }
      }
    } = this.props;
    return (
      <Col xs={12} className="homeContainer">
        <CountdownTimer />
        <Row>
          <Container className="bg-primary">
            <Breadcrumbs />
            <section className="mb-4 px-4 pb-4 mb-2 border-container">
              <Col xs={12} className="text-center mb-4">
                <h1 className="first-title text-center color-white my-4 interna-resultados" dangerouslySetInnerHTML={{ __html:  info.title}}></h1>
              </Col>
              <Col xs={12} className="text-center mb-4">
                <h2 className="third-title color-white" dangerouslySetInnerHTML={{ __html:  info.description}}></h2>
              </Col>
              <ResultsPageContainer dateparam={date} />
            </section>
          </Container>
        </Row>
      </Col>
    );
  }
}

const mapStateToProps = (state) => {
  const { loading, error } = state.general.pages;
  return {
    loading,
    error,
    info: getPageInfo(state, 'resultados')
  };
};

export default connect(mapStateToProps)(Results);
